import { Col, FloatingLabel, FormCheck, FormControl, Row } from "react-bootstrap";
import Validator from "../../../../services/Validator";
import CommonUtils from "../../../../utils/common";
import { useAuthState } from "../../../../context/AuthContext";
import EnergoTooltip from "../../../shared/EnergoTooltip";


const RegisterMask = ({data, setData, formError, setFormError, hwMode}) => {

    const { tooltipsTrigger, tooltips } = useAuthState();
    const VALIDATOR = new Validator();
    const UTILS = new CommonUtils();


    const registerHandler = (e) => {
        const isChecked = e.target.checked;
        setFormError({});

        if (isChecked) {
            setData(prev => ({
                ...prev,
                register: isChecked
            }));
        } else {
            setData(prev => ({
                ...prev,
                register: isChecked,
                registerDate: "",
                zaehlerstand1: "",
                zaehlerstand2: "",
                useMtu: false,
                mtuName: "",
                mtuDirect: false,
                mtuPaysOverTransfer: false,
                mtuAccountOwner: "",
                mtuIban: ""
            }));
        }
    }

    const mtuHandler = (e) => {
        const isChecked = e.target.checked;
        setFormError({});

        if (isChecked) {
            setData(prev => ({
                ...prev,
                useMtu: isChecked
            }));
        } else {
            setData(prev => ({
                ...prev,
                useMtu: isChecked,
                mtuName: "",
                mtuDirect: false,
                mtuPaysOverTransfer: false,
                mtuAccountOwner: "",
                mtuIban: ""
            }));
        }
    }

    const mtuPaysOverTransferHandler = (e) => {
        const isChecked = e.target.checked;
        setFormError({});

        if (isChecked) {
            setData(prev => ({
                ...prev,
                mtuPaysOverTransfer: isChecked,
            }));
        } else {
            setData(prev => ({
                ...prev,
                mtuPaysOverTransfer: isChecked
            }));
        }
    }

    const ibanHandler = (e) => {
        const inputValue = e.target.value;

        // replace any characters that aren't digit or letter
        const formatedValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');

        // group character in 4 block
        const formated4group = formatedValue.substring(0).replace(/(.{4})(?!$)/g, "$1 ");

        // set new value with uppercase
        setData(prev => ({
            ...prev,
            mtuIban: formated4group.toUpperCase()
        }));
    }

    return (
        <>
            <p className="text-energo"><b>Anmeldedaten</b></p>
            <Row className="mt-3 align-items-center" hidden={!hwMode}>
                <Col xs="12" md="6" xl="4" className="d-flex">
                    <FormCheck
                        className="me-2"
                        label="Anlage bei Energielieferant anmelden"
                        checked={data.register}
                        onChange={e => registerHandler(e)}
                    />
                    <EnergoTooltip tKey="106" position="right" />
                </Col>
                <Col xs="12" md="6" xl="8">
                    {
                        data.register === true ?
                            <small>Anlage wird bei ENERGO hinzugefügt und bei Energielieferant angemeldet</small> :
                        data.register === false ?
                            <small>Anlage wird nur bei ENERGO hinzugefügt.</small> :
                        null
                    }
                </Col>
            </Row>
            <Row className="mt-3 align-items-center">
                <Col xs="12" md="5" xl="4">
                    <FloatingLabel label="Anlage anmelden am">
                        <FormControl
                            disabled={data.register === false}
                            type="date"
                            placeholder="Anlage anmelden am"
                            value={data.registerDate}
                            onChange={e => {setData(prev => ({...prev, registerDate: e.target.value})); setFormError({})}}
                            isValid={VALIDATOR.dateValid(data.registerDate)}
                            isInvalid={formError.registerDate}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="7" xl="8">
                    <small hidden={!data.registerDate || UTILS.compareDate(new Date(data.registerDate), ">", new Date())}>
                        Das Anmeldedatum liegt in der Vergangenheit. Die Anmeldung 
                        wird in Abstimmung mit dem Energielieferanten am frühest 
                        möglichen Zeitpunkt durchgeführt.
                    </small>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="6" xl="6" hidden={data.smartmeter === true}>
                    <FloatingLabel label={`Zählerstand von ${data.x_zaehlernummer_01} ${data.x_is_smartmeter_01 === true ? "(wenn vorhanden)":""}`}>
                        <FormControl
                            disabled={data.register === false}
                            placeholder="Zählerstand"
                            value={data.zaehlerstand1}
                            onChange={e => {setData(prev => ({...prev, zaehlerstand1: e.target.value})); setFormError({})}}
                            isValid={data.zaehlerstand1 && data.zaehlerstand1 !== "" && VALIDATOR.IsZaehlerstand(data.zaehlerstand1)}
                            isInvalid={formError.zaehlerstand1}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="6" xl="6" hidden={data.smartmeter === true || !data.secondZaehler}>
                    <FloatingLabel label={`Zählerstand von ${data.x_zaehlernummer_02}  ${data.x_is_smartmeter_01 === true ? "(wenn vorhanden)":""}`}>
                        <FormControl
                            disabled={data.register === false}
                            placeholder="Zweiter Zählerstand"
                            value={data.zaehlerstand2}
                            onChange={e => {setData(prev => ({...prev, zaehlerstand2: e.target.value})); setFormError({})}}
                            isValid={data.zaehlerstand2 && data.zaehlerstand2 !== "" && VALIDATOR.IsZaehlerstand(data.zaehlerstand2)}
                            isInvalid={formError.zaehlerstand2}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            {hwMode &&
                <>
                    <Row className="mt-3 align-items-center">
                        <Col xs="12" md="12" xl="6" className="d-flex">
                            <FormCheck
                                disabled={data.register === false}
                                className="me-2"
                                label="Abrechnung über Messtechnikunternehmen"
                                checked={data.useMtu}
                                onChange={e => mtuHandler(e)}
                            />
                            <EnergoTooltip tKey="107" position="right" />
                        </Col>
                        <Col xs="12" md="12" xl="6" hidden={!data.useMtu}>
                            <FloatingLabel label="Name des Messtechnikunternehmens">
                                <FormControl
                                    placeholder="Name des Messtechnikunternehmens"
                                    value={data.mtuName}
                                    onChange={e => {setData(prev => ({...prev, mtuName: e.target.value})); setFormError({})}}
                                    isValid={data.mtuName &&  data.mtuName.length > 3}
                                    isInvalid={formError.mtuName}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mt-3" hidden={!data.useMtu}>
                        <Col xs="12" md="5" xl="6" className="d-flex">
                            <FormCheck
                                className="me-2"
                                label="Direktverrechnung"
                                checked={data.mtuDirect}
                                onChange={e => {setData(prev => ({...prev, mtuDirect: e.target.checked})); setFormError({})}}
                            />
                            <EnergoTooltip tKey="108" position="right" />
                        </Col>
                        <Col xs="12" md="7" xl="6" hidden={!data.mtuDirect}>
                            <FormCheck
                                label="Messtechnikunternehmen zahlt per Überweisung"
                                checked={data.mtuPaysOverTransfer}
                                onChange={e => mtuPaysOverTransferHandler(e)}
                            />
                        </Col>
                    </Row>
                    <Row className="mt-3" hidden={!data.useMtu || !data.mtuDirect}>
                        <p hidden={data.mtuDirect === true && data.mtuPaysOverTransfer === false}>
                            <small>Die IBAN und Kontoinhaber muss zur Rücküberweisung von Guthaben angegeben werden.</small>
                        </p>
                        <Col xs="12" md="5" xl="6">
                            <FloatingLabel label="Kontoinhaber">
                                <FormControl
                                    placeholder="Kontoinhaber"
                                    value={data.mtuAccountOwner}
                                    onChange={e => {setData(prev => ({...prev, mtuAccountOwner: e.target.value})); setFormError({})}}
                                    isValid={data.mtuAccountOwner && data.mtuAccountOwner.length > 3}
                                    isInvalid={formError.mtuAccountOwner}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col xs="12" md="7" xl="6">
                            <FloatingLabel label="IBAN">
                                <FormControl
                                    placeholder="IBAN"
                                    value={data.mtuIban}
                                    onChange={e => {ibanHandler(e); setFormError({})}}
                                    isValid={data.mtuIban && VALIDATOR.ibanValid(data.mtuIban.replace(/\s+/g, ''))}
                                    isInvalid={formError.mtuIban}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                </>
            }
        </>
    )
}
export default RegisterMask;